"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getQuestions = exports.getButtonStyle = exports.getProfilingTitleStyle = exports.getQuestionsTitleStyle = exports.getCardStyle = exports.getPageStyle = exports.SurveyCard = exports.SurveyContainer = void 0;
const modules_1 = require("../modules");
const SurveyContainer = (modules, type, style) => new modules_1.ContainerModule({
    modules,
    style: type === "header"
        ? { marginBottom: 30, maxWidth: "660px", width: "100%", ...style }
        : { maxWidth: 660, width: "100%", ...style },
});
exports.SurveyContainer = SurveyContainer;
const SurveyCard = ({ modules, variant, image, compact, style, url, }) => new modules_1.CardModule({
    compact,
    image,
    url,
    backgroundColor: "#FAFBFB",
    variant,
    style,
    modules,
});
exports.SurveyCard = SurveyCard;
const getPageStyle = (config) => {
    var _a;
    switch ((_a = config.fields.layout) === null || _a === void 0 ? void 0 : _a.content) {
        case "wave":
            return { paddingTop: 0 };
        default:
            return {};
    }
};
exports.getPageStyle = getPageStyle;
const getCardStyle = (config, extra) => {
    var _a;
    switch ((_a = config.fields.layout) === null || _a === void 0 ? void 0 : _a.content) {
        case "angular":
            return {
                border: 0,
                borderRadius: 0,
                background: "white",
                clipPath: "polygon(0% 0%, 100% 0%, 100% calc(100% - 30px), calc(100% - 30px) 100%, 0 100%)",
                ...extra,
            };
        case "wave":
            return {
                padding: 0,
                border: 0,
                borderRadius: 0,
                background: "none",
                ...extra,
            };
        case "boxy":
            return {
                borderRadius: 10,
                border: "2px solid #CDCECE",
                background: "#FAFBFB",
            };
        default:
            return { ...extra };
    }
};
exports.getCardStyle = getCardStyle;
const getQuestionsTitleStyle = (config) => {
    var _a;
    switch ((_a = config.fields.layout) === null || _a === void 0 ? void 0 : _a.content) {
        case "boxy":
            return { textAlign: "center" };
        default:
            return {};
    }
};
exports.getQuestionsTitleStyle = getQuestionsTitleStyle;
const getProfilingTitleStyle = (config) => {
    var _a;
    switch ((_a = config.fields.layout) === null || _a === void 0 ? void 0 : _a.content) {
        case "boxy":
            return { textAlign: "center" };
        default:
            return {};
    }
};
exports.getProfilingTitleStyle = getProfilingTitleStyle;
const getButtonStyle = (config) => {
    var _a;
    switch ((_a = config.fields.layout) === null || _a === void 0 ? void 0 : _a.content) {
        case "angular":
            return {
                borderRadius: 0,
                clipPath: "polygon(14px 0%, 100% 0%, 100% calc(100% - 14px), calc(100% - 14px) 100%, 0 100%, 0% 14px)",
            };
        case "wave":
            return {
                borderRadius: 100,
            };
        default:
            return {};
    }
};
exports.getButtonStyle = getButtonStyle;
const getQuestions = (modules, config) => {
    var _a;
    switch ((_a = config.fields.layout) === null || _a === void 0 ? void 0 : _a.content) {
        case "angular":
        case "wave":
        case "boxy":
            return modules.map((mod) => {
                mod.noBorder = true;
                return mod;
            });
        case "default":
        default:
            return modules;
    }
};
exports.getQuestions = getQuestions;
//# sourceMappingURL=helpers.js.map